/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Playdata_Pricing_HeadingInputs */

const ja_playdata_pricing_heading = /** @type {(inputs: Playdata_Pricing_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プラン・価格`)
};

const en_playdata_pricing_heading = /** @type {(inputs: Playdata_Pricing_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pricing`)
};

/**
* | output |
* | --- |
* | "Pricing" |
*
* @param {Playdata_Pricing_HeadingInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const playdata_pricing_heading = /** @type {((inputs?: Playdata_Pricing_HeadingInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Playdata_Pricing_HeadingInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_playdata_pricing_heading(inputs)
	return en_playdata_pricing_heading(inputs)
});